import React from 'react';
import { withTranslation } from "react-i18next";
import { OverlayTrigger,Tooltip} from 'react-bootstrap';


const AIConfigButton = ({
	t,
	id,
	name,
	value,
	checked,
	classes,
	toolTip,
	disabled = false,
	onCheck
}) => {


	return (
		<OverlayTrigger
			placement="top"
			overlay={
				toolTip
					? <Tooltip id="button-tooltip">{toolTip}</Tooltip>
					: <></>
			}>
			<span id={`button-${id}`} key={`button-${id}`} >
				<input type="checkbox"
					className="btn-check"
					id={id}
					checked={checked}
					value={value}
					onChange={(e) => onCheck()}
					autoComplete="off"
					disabled={disabled} />
				<label className={` ${classes}`}
					htmlFor={id}>
					{name}
				</label>
			</span>
		</OverlayTrigger >
	);
};

export default withTranslation()(AIConfigButton);